import { Menu as AntMenu, Select as AntSelect } from 'antd';
import { SelectProps as AntSelectProps } from 'rc-select/lib/Select';
import { Link } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';

import { StyleConstantsEnum } from '@style/style.constants';

import Icon from '@asset/check.icon.svg';
import SelectArrow from '@asset/select-arrow.icon.svg?react';
import { ColorEnum } from '@enum/style/color.enum';

export const DropdownClassName = 'application-dropdown';

export const DropdownStyle = createGlobalStyle`
  .${DropdownClassName} {
    padding: 0;
    border-radius: 0;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    overflow: inherit;

    border-width: 1px;
    border-style: solid;
    border-color: ${(props) => props.theme.Select.applicationDropDown.borderActiveColor};
    background-color: ${(props) => props.theme.Select.applicationDropDown.backgroundActiveColor};

    &:before {
      content: '';
      display: block;
      position: absolute;
      top: -6px;
      height: 6px;
      left: -1px;
      width: calc(100% + 2px);
      border-left-width: 1px;
      border-left-style: solid;
      border-right-width: 1px;
      border-right-style: solid;
      border-color: ${(props) => props.theme.Select.applicationDropDown.borderActiveColor};
      background-color: ${(props) => props.theme.Select.applicationDropDown.backgroundActiveColor};
    }

    & .ant-select-item {
      border-radius: 0;
      padding: 8px 16px;

      &:is(.ant-select-item-option-active,.ant-select-item-option-selected) {
        background-color: ${(props) => props.theme.Select.applicationDropDown.backgroundSelectedColor};
      }

      &.ant-select-item-option-selected {
        position: relative;

        &:after {
          content: '';
          display: block;
          position: absolute;
          right: 16px;
          top: 8px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-image: url('${Icon}');
        }

        & .ant-select-item-option-content {
          font-weight: 600;
        }
      }
    }

    & .ant-select-item-option-content {
      color: ${(props) => props.theme.Select.applicationDropDown.colorText};
      font-size: 14px;
      line-height: 18px;
    }
  }
`;

interface SelectProps {
  isBlack?: boolean;
}

export const Select = styled(AntSelect).attrs({
  suffixIcon: <SelectArrow />,
})<SelectProps & AntSelectProps>`
  &.ant-select {
    width: 100%;
    height: 100%;
    position: relative;

    ${({ isBlack = false }) =>
      isBlack &&
      `& .ant-select-selection-placeholder {
      color: ${ColorEnum.Black10};
    }`}

    & .ant-select-selector {
      background-color: ${(props) => props.isBlack && props.theme.Select.applicationDropDown.backgroundColor};
      border-radius: 4px;
      border-color: ${(props) => props.isBlack && props.theme.Select.applicationDropDown.borderColor};
      height: ${({ size }) => (size === 'small' ? 32 : size === 'large' ? 48 : 40)}px !important;
      align-items: center;
      padding: 0 16px;

      & .ant-select-selection-item {
        color: ${(props) => props.isBlack && props.theme.Select.applicationDropDown.colorText};
        font-size: 16px;
        line-height: 18px;
        letter-spacing: 0.3px;
      }
    }

    &:hover .ant-select-selector {
      border-color: ${(props) => props.isBlack && props.theme.Select.applicationDropDown.borderActiveColor} !important;
    }

    & .ant-select-arrow {
      margin-top: -6px !important;

      & svg {
        fill: ${(props) => props.theme.Select.applicationDropDown.borderColor};
      }
    }

    &.ant-select-open {
      & .ant-select-selector {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-color: ${(props) =>
          props.isBlack && props.theme.Select.applicationDropDown.borderActiveColor} !important;
        background-color: ${(props) => props.isBlack && props.theme.Select.applicationDropDown.backgroundActiveColor};
      }

      & .ant-select-arrow {
        & svg {
          transform: rotate(180deg);
          fill: ${(props) => props.theme.Select.applicationDropDown.borderActiveColor};
        }
      }
    }
  }
`;

export const MenuLink = styled(Link)``;

export const Menu = styled(AntMenu)`
  & .ant-menu-item {
    display: flex;
    height: 46px;
    width: 100%;
    padding: 4px 16px;
    background-color: transparent;
    align-items: center;
    font-size: 16px;
    margin: 0;
    margin-bottom: 2px;

    & ${MenuLink} {
      font-size: 16px;
      font-family: ${StyleConstantsEnum.TitleFontFamily};
    }

    & > svg {
      width: 24px;
      height: 24px;
      fill: ${(props) => props.theme.Menu.colorIcon};
    }

    &.ant-menu-item-selected,
    &.ant-menu-item-active {
      border-top-right-radius: 7px;
      border-bottom-left-radius: 7px;
    }

    &.ant-menu-item-selected {
      color: ${(props) => props.theme.Menu.colorText};
      background-color: ${(props) => props.theme.Menu.colorBgActive};

      & > svg {
        fill: ${(props) => props.theme.Menu.colorText};
      }
    }
    & .ant-menu-title-content {
      display: block;
      width: 100%;
    }
  }
`;
